import controller from './blog.controller';
import templateBase from './templates/blog-base.view.html';
import templateT1 from './templates/blog-t1.view.html';
import templateT13 from './templates/blog-t13.view.html';
import templateT15 from './templates/blog-t15.view.html';
import templateAD from './templates/blog.view-adaptative.html';

let BlogComponent = {
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if(__env.adaptative) { return templateAD; }
    else{
        if(response.BLOG.component == 'template_t1'){return templateT1}
        if(response.BLOG.component == 'template_t13'){return templateT13}
        if(response.BLOG.component == 'template_t15'){return templateT15}
        else {return templateBase;}
    }

}

export default BlogComponent;


// WEBPACK FOOTER //
// ./www/components/blog/blog.component.js